import anonymousRequest from 'Chores/anonymousRequest';
import { PASSWORD_RESET_REQUEST_CODE, PASSWORD_RESET_RESET } from 'Chores/Api';

/**
 * Request a verification code to be sent to the given email.
 * POST /api/app/password-reset/request-code
 * @param {string} email
 * @return {Promise<{success: boolean, message: string}>}
 */
export const requestResetCode = (email) =>
  anonymousRequest.post(PASSWORD_RESET_REQUEST_CODE, { email });

/**
 * Reset the password using the emailed verification code.
 * POST /api/app/password-reset/reset
 * @param {string} email
 * @param {string} code
 * @return {Promise<{success: boolean, temporaryPassword: string, message: string}>}
 */
export const resetPassword = (email, code) =>
  anonymousRequest.post(PASSWORD_RESET_RESET, { email, code });
